import { Modal } from "@circleco/compass/components/Modal";
import { useEffect } from "react";

import { t } from "@/i18n-js/instance";
import { PlansProvider } from "@/react/components/SettingsApp/Plan/RegularPlan/PlansContext";
import { useEventsTracker } from "@/react/hooks/analytics/useEventsTracker";

import { LeftPane } from "./LeftPane";
import { RightPane } from "./RightPane";

const I18N_ROOT = "pricing_plans.upgrade_modal.enterprise_plus";

interface EnterprisePlusModalComponentProps {
  onOpenChange: (open: boolean) => void;
  open: boolean;
  source?: string;
}

export const EnterprisePlusModalComponent = ({
  open,
  onOpenChange,
  source,
}: EnterprisePlusModalComponentProps) => {
  const { trackEvent } = useEventsTracker();

  useEffect(() => {
    trackEvent("enterprise_plus_modal.viewed", { source });
  }, [trackEvent, source]);

  return (
    <Modal.Root open={open} onOpenChange={onOpenChange} size="xl">
      <Modal.Content>
        <Modal.Header title={t(`${I18N_ROOT}.title`)} showCloseButton />
        <Modal.Body>
          <PlansProvider>
            <div className="grid grid-cols-1 gap-8 md:grid-cols-2 md:gap-x-10">
              <div className="order-2 md:order-1">
                <LeftPane />
              </div>
              <div className="order-1 md:order-2">
                <RightPane source={source} />
              </div>
            </div>
          </PlansProvider>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
};
